import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'se-lock-unlock-renderer',
    templateUrl: './lock-unlock-renderer.component.html',
    styleUrls: ['./lock-unlock-renderer.component.scss'],
    standalone: false
})
export class LockUnlockRendererComponent implements ICellRendererAngularComp {
    canUnlock: boolean;
    locked: boolean;
    tooltip: string;

    private data: any;
    private unlockWorklistItem: any;

    constructor(private translate: TranslateService) {}

    refresh(params): boolean {
        this.updateParams(params);

        return true;
    }

    agInit(params): void {
        this.updateParams(params);
    }

    invokeUnlockMethod($event: MouseEvent) {
        $event.stopPropagation();
        this.unlockWorklistItem($event, this.data);
    }

    private createTooltip(params) {
        if (!this.locked) {
            return '';
        }

        const tooltip = params.context.canUnlockWorklistItem ? this.translate.instant('ClickToUnlock') : '';
        if (params.userField && !!params.data[params.userField]) {
            return tooltip + '\n' + this.translate.instant('LockedBy', { p0: params.data[params.userField] });
        }

        return tooltip;
    }

    private updateParams(params) {
        if (!params.lockedField) {
            throw new Error('You need to specify "lockedField" to use LockUnlockRendererComponent');
        }

        this.locked = params.data[params.lockedField];
        this.tooltip = this.createTooltip(params);

        this.data = params.data;
        this.canUnlock = params.context.canUnlockWorklistItem;
        this.unlockWorklistItem = params.context.unlockWorklistItem;
    }
}
